// Demo site (Try Teamio) — the demo shell's rules (plan Task 6.4, trimmed by the SCOPE RULE): the "View as" personas,
// the "Demo — not actually sent" tag on simulated messages, the thread menu's "Simulate a patient reply", and the
// messages a failed demo action shows. Pure and import-free: cypress/node-tests/demo-shell.test.js executes this file.

// Mirror of demo-service lib/personas.js (the backend owns the roles; a request names only the key). Never Super Admin.
export const DEMO_PERSONAS = Object.freeze([
  Object.freeze({ key: 'owner', label: 'Owner', role: 'Admin', employeeID: 'de3a0000-0000-4000-8000-000000000001' }),
  Object.freeze({ key: 'manager', label: 'Office manager', role: 'Manager', employeeID: 'de3a0000-0000-4000-8000-000000000002' }),
  Object.freeze({ key: 'frontdesk', label: 'Front desk', role: 'Employee', employeeID: 'de3a0000-0000-4000-8000-000000000003' }),
  Object.freeze({ key: 'billing', label: 'Billing (outsourced)', role: 'Outsourced', employeeID: 'de3a0000-0000-4000-8000-000000000004' }),
]);

/** The persona signed in as this EmployeeID, or null. Exact match only. */
export function personaForEmployee(employeeID) {
  if (typeof employeeID !== 'string') return null;
  return DEMO_PERSONAS.find(p => p.employeeID === employeeID) || null;
}

export const SIMULATED_SEND_TAG = 'Demo — not actually sent';

/**
 * A message the backend simulated (Firestore `simulated: true`, set by the layer's guarded send) shows the tag on its
 * timestamp line, the one line the chat library draws on every bubble. The text is never changed. Anything else is
 * returned as is (same reference), so a real practice's messages pass through untouched.
 */
export function tagSimulatedSend(msg) {
  if (!msg || msg.simulated !== true) return msg;
  const ts = typeof msg.timestamp === 'string' ? msg.timestamp : '';
  if (ts.indexOf(SIMULATED_SEND_TAG) !== -1) return msg;
  return { ...msg, timestamp: ts ? `${ts} · ${SIMULATED_SEND_TAG}` : SIMULATED_SEND_TAG };
}

export const SIMULATE_REPLY_ACTION = Object.freeze({ name: 'demoSimulateReply', title: 'Simulate a patient reply' });

/** The thread menu: a demo session gets "Simulate a patient reply"; anyone else gets `base` itself. */
export function demoRoomActions(base, isDemo) {
  if (isDemo !== true) return base;
  return [...base, { ...SIMULATE_REPLY_ACTION }];
}

/** What a failed "View as" ('switch') or "Simulate a patient reply" ('simulate') says. Never the server's text. */
export function demoErrorMessage(err, kind) {
  const res = err && err.response;
  const status = res && res.status;
  const code = res && res.data && res.data.code;
  if (status === 403 && code === 'demo_expired') return "This demo has ended. Book a call and we'll set you up again.";
  if (kind === 'simulate') {
    if (status === 429) return "You've reached today's limit of simulated replies. Try again tomorrow.";
    if (status === 404 || status === 422) return "Simulated replies work in the sample patients' conversations.";
    return "Couldn't simulate a reply. Please try again.";
  }
  return "Couldn't switch roles. Please try again.";
}
